<template>
  <v-dialog v-model="isActive" persistent @keydown.esc="close" :max-width="!fullscreen ? maxWidth : ''" scrollable
            :fullscreen="fullscreen" :transition="fullscreen ? 'dialog-bottom-transition' : 'dialog-transition'">
    <v-card :class="fullscreen ? 'form-dialog--fullscreen' : ''">

      <v-progress-linear class="progress" color="accent" indeterminate v-if="sending"/>

      <v-card-title class="title">

        <v-btn v-if="fullscreen" icon @click="close">
          <v-icon>clear</v-icon>
        </v-btn>

        <slot name="btn-confirm" :validateFunction="validateForm" v-if="fullscreen">
          <v-btn v-if="!$store.getters.isAbbonamentoExpired" color="accent" @click="validateForm" :disabled="!valid" :loading="sending">
            {{$t('azioni.conferma') }}
          </v-btn>
        </slot>

        <slot name="title">
          <span>{{ title }}</span>
        </slot>

      </v-card-title>

      <v-card-text>
        <v-form v-model="valid" ref="form" lazy-validation @submit.prevent="validateForm" :id="'form-dialog-' + _uid">
          <input v-show="false" type="submit" aria-label="hidden-submit"/>
          <v-container grid-list-lg>
            <v-layout wrap row justify-space-between>
              <slot/>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions v-if="!fullscreen">
        <v-spacer/>
        <v-btn color="accent" flat @click="close">{{ $t('azioni.annulla') }}</v-btn>
        <slot name="btn-confirm" :validateFunction="validateForm">
          <v-btn v-if="!$store.getters.isAbbonamentoExpired" color="accent" @click="validateForm" :disabled="!valid" :loading="sending">
            {{$t('azioni.conferma') }}
          </v-btn>
        </slot>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
import Toggleable from '@/mixins/toggleable'

//  Componente usato nei dialog con form, per esmpio in PrenotazioneDialog, AgricoltoriDialog,...
export default {
    name: 'FormDialog',
    mixins: [Toggleable],
    props: {
        title: String,
        sending: Boolean,
        maxWidth: {
            type: String,
            default: '1000px'
        },
        fullscreen: Boolean
    },
    data: () => ({
        valid: true
    }),
    watch: {
        isActive (val) {
            this.$emit('input', val)
            if (val && this.$refs.form) {
                this.$refs.form.resetValidation()
            }
        }
    },
    methods: {
        validateForm () {
            //  Viene eseguita la validazione di tutti i campi nella form prima di inviare la conferma
            if (this.$refs.form.validate()) {
                this.$emit('confirm')
            }
        },
        close () {
            this.isActive = false
            this.$emit('close')
        },
        reset () {
            //  Metodo usato solo in PasswordDialog, resetta tutti i campi della form.
            //  Negli altri dialog viene fatto un reset manuale tramite il mixin Sendable
            this.$refs.form.reset()
        }
    }
}
</script>

<style lang="scss" scoped>
  .progress {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    margin-top: 0;
  }

  .form-dialog--fullscreen {
    .v-card__text {
      min-height: calc(100vh - 60px);
      overflow-y: scroll;
    }

    .v-card__title /deep/ .v-btn {
      position: absolute;
      right: 16px;

      &:first-child {
        right: unset;
        left: 16px;
      }
    }
  }

  @media only screen and (min-width: 960px) {
    .form-dialog--fullscreen .v-card__title {
      width: 900px;
      margin: auto;
      padding-left: 8px !important;
    }
  }

  @media only screen and (min-width: 1264px) {
    .form-dialog--fullscreen .v-card__title {
      width: 1185px;
      margin: auto;
      padding-left: 8px !important;
    }
  }
</style>
